import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
const jobSlice = createSlice({
  name: "role",
  initialState: {
    jobs: [],
    loading: false,
    error: null,
  },
  reducers: {
    updateReduxJobs: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.jobs = action.payload;
      }
      // state.jobs = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { updateReduxJobs } = jobSlice.actions; // No additional actions defined here

export default jobSlice.reducer;
